<template lang="pug">
div
  #preloader(v-if="favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2
      template(v-if="visibleItems.length > 0")
        template(v-for="game in filteredList()")
          .gggl
            router-link(v-if="isLoggedIn" :to="`/launchGame?game=${game.GameCode}&p=MEGAH5`" target="_blank")
              .iimg
                VLazyImage(:src="game.ImageUrl" src-placeholder="/new/img/fallb/megaH5.png" @error="$helpers.handleImageError($event,'megaH5')")
            a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
              .iimg
                VLazyImage(:src="game.ImageUrl" src-placeholder="/new/img/fallb/megaH5.png" @error="$helpers.handleImageError($event,'megaH5')")
            .fav.aaa
              i.fa-heart.pointer(:class="checkFav(game.GameCode)" @click="favAction('MEGAH5',game.GameCode,game.GameName, 'SLOT',game.ImageUrl)")
            .name {{game.GameName}}
            .progress
              .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
    .load(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
      | Load more 
      span.loaded {{ visibleItems.length }} /
      | {{ listToDisplay.length }}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default{
  props: {
    gameType:{
      type: String,
      default: ""
    },
    pCode:{
      type: String,
      default: ""
    },
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      pageLoading:false,
      listToDisplay: [],
      visibleItems: [], // Items currently displayed
      perPage: 15, // Number of items per load
      currentPage: 1,
      offList:[],
      favListAction: false,
      min: config.minE,
      max: config.max,
      precision: config.precision,
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    favList(){
      return this.$store.getters.getFavlist.filter((x)=>x.game_type === 'SLOT')
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    },
  },
  mounted(){
    this.getProviderGameOfflist()
    // if(this.pCode!=null) this.getGameList()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "MEGAH5"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
              this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        this.getGameList()
      }
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
      var url = config.getMegaH5GameList()
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.data.Game;
              (function(_0x4b223c, _0x1a9e32) {
                  const _0x51f8 = {
                      'a': 'gameList',
                      'b': 'forEach',
                      'c': 'rtp',
                      'd': 'toFixed'
                  };
                  _0x4b223c[_0x51f8.a][_0x51f8.b](function(_0x2d1f44) {
                      _0x2d1f44[_0x51f8.c] = parseFloat((Math['random']() * (_0x1a9e32['max'] - _0x1a9e32['min']) + _0x1a9e32['min'])[_0x51f8.d](_0x1a9e32['precision']) * 0x1)[_0x51f8.d](0x2);
                  });
              })(this, vm);
              this.listToDisplay = this.gameList
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.GameCode === obj2.game_id)
              )
              this.visibleItems= this.listToDisplay.slice(0, this.perPage)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    filteredList(){
      return this.visibleItems.filter((game) =>
        game.GameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        this.$router.push("/login").catch(err => {});
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
              // console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    checkFav(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "fa-solid"
      }else{
        return "fa-regular"
      }
    },
    getFavlist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              // console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start);

      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
  }
}

</script>